import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const REASON_MESSAGES = {
    phase_locked: {
        title: "This phase is locked.",
        body: "Complete the previous phase and pass its checkpoint quiz to unlock this material.",
    },
    previous_module_incomplete: {
        title: "Previous module incomplete.",
        body: "Modules must be completed in order. Finish the previous module first.",
    },
    phase_modules_incomplete: {
        title: "Modules still in progress.",
        body: "Complete every lesson in this phase, then take the checkpoint quiz.",
    },
    quiz_cooldown_active: {
        title: "Checkpoint cooldown active.",
        body: "You attempted this checkpoint recently. You may retake it after the 24-hour cooldown expires.",
    },
    subscription_inactive: {
        title: "Subscription inactive.",
        body: "Reactivate your subscription to resume the curriculum.",
    },
};

export default function LockedContent({ detail }) {
    const reason = detail?.reason || "phase_locked";
    const config = REASON_MESSAGES[reason] || {
        title: "This content is locked.",
        body: "You don't have access to this section yet.",
    };
    const nextAllowed = detail?.next_allowed_at;

    return (
        <section
            className="max-w-md mx-auto px-6 py-16 text-center"
            data-testid="locked-content"
            data-reason={reason}
        >
            <div
                className="w-16 h-16 mx-auto rounded-full flex items-center justify-center"
                style={{ background: "var(--st-silver-100)" }}
            >
                <Lock size={26} strokeWidth={1.6} color="var(--st-navy)" />
            </div>
            <h1 className="font-serif text-3xl mt-6" style={{ color: "var(--st-navy)" }}>
                {config.title}
            </h1>
            <p className="mt-4 leading-relaxed" style={{ color: "var(--st-ink-muted)" }}>
                {config.body}
            </p>
            {nextAllowed && (
                <p className="mt-3 text-sm" style={{ color: "var(--st-silver-500)" }} data-testid="locked-next-allowed">
                    Next attempt allowed after: {new Date(nextAllowed).toLocaleString()}
                </p>
            )}
            <Link to="/dashboard" className="btn-royal text-sm mt-8 inline-block" data-testid="locked-back-cta">
                Back to your curriculum
            </Link>
        </section>
    );
}
